<template>
  <div :class="[_isMobile() ? 'mobile' : '']">
    <div class="homeIcon" ><i class="iconfont" @click="$router.push({path:'/'})">&#xe751;</i></div>
    <div
      class="login_backgroun"
      :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"
    >
      <div class="login_content">
        <div class="login_right login_box">
          <p class="title">注册学习系统</p>
          <Register />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import { TENANT_CONFIG } from "@/store/mutation-types";
import Register from "@/components/user/Register";
import { mixinDevice } from "@/utils/mixin.js";

export default {
  mixins: [mixinDevice],
  components: {
    Register,
  },
  data() {
    return {
      backgroundImage: Vue.ls.get(TENANT_CONFIG).loginBg,
    };
  },
  created() {},
  mounted() {
    window.document.title = "注册";
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.homeIcon{
  position: fixed;
  top: 20px;
  left:20px;
  z-index: 99;
  cursor: pointer;
  .iconfont{
    font-size: 24px;
  }
}
.mobile {
  .login-wrap {
    padding: 0 !important;
  }
}
.login-wrap {
  padding: 40px 40px;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000039;
}

.login_backgroun {
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;
  position: relative;
  .login_content {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 800px;
    min-height: 400px;
    .login_box {
      width: 50%;
      height: 100%;
      margin: 0 auto;
      // float: left;
      .title {
        font-size: 20px;
        color: #333;
        font-weight: bold;
        margin-bottom: 15px;
      }
    }
    .login_left {
      background: #ffffff21;
    }
    .login_right {
      background: #fff;
      border-radius: 20px;
      padding: 20px;
      box-sizing: border-box;
    }
  }
}
</style>